module.exports = __webpack_public_path__ + "img/logo.2382d72b.png";